import React, { useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import {
  PageWrapper,
  Flex,
  MainHeadline,
  Button,
  GridWrapper,
  ItemsGrid,
  GridItem,
  PageFooter,
} from 'styling/GlobalStyles'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { useNavigate } from 'react-router-dom'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import {
  clearDepartmentsList,
  archiveDepartment,
  getDepartments,
} from 'features/departments/departmentsSlice'
import { Pagination } from 'components/Pagination/Pagination'
import { setConfirmModal } from 'features/global/globalSlice'
import { getParams, handlePagination, } from 'utils/helpers'
import { ITableItem, ModalTypes } from 'types/global.interface'
import useQueryPagination from 'hooks/useQueryPagination'
import { DepartmentsModal } from './DepartmentsModal'

export const Departments = () => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const { departments, totalPages } = useSelector((state: RootState) => state.departments)
  const [params, setParams] = useState<any>(getParams({ location }))
  const [modal, setModal] = useState({ isOpen: false, name: null, id: null })

  useQueryPagination({ fetchFunctions: [getDepartments], cleanUpFunctions: [clearDepartmentsList], params })

  const handleRemove = (id: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(archiveDepartment(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: departments.length < 2,
        },
        word: 'archive department',
      }),
    )
  }

  return (
    <>
      <NavBar defaultValue={params.q} input placeholder='Search Departments...' setParams={setParams} limit={30} />
      <PageWrapper>
        <Flex width='100%' between mb='16'>
          <MainHeadline>Departments</MainHeadline>
          <Button orange onClick={() => setModal({ isOpen: true, name: null, id: null })}>
            Add Department
          </Button>
        </Flex>
        <GridWrapper>
          <ItemsGrid columns={3}>
            {departments.length ? (
              departments.map((item: ITableItem, key: number) => {
                return (
                  <GridItem key={key}>
                    <p onClick={() => setModal({ isOpen: true, name: item.name, id: item.id })}>{item.name}</p>
                    <Flex center justcenter onClick={() => handleRemove(item.id)}>
                      <RemoveCircle />
                    </Flex>
                  </GridItem>
                )
              })
            ) : (
              <NoItems title='Departments' />
            )}
          </ItemsGrid>
        </GridWrapper>
      </PageWrapper>
      {modal.isOpen && <DepartmentsModal value={{ name: modal.name, id: modal.id }} closeModal={() => setModal({ isOpen: false, name: null, id: null })} />}
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 30)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
